import React, {Component} from 'react'
import PrintPreview from '../PrintPreview'
import AdminStore from 'stores/AdminStore'
import PdfStore from 'stores/PdfStore'
import Container from './Container'
import PaperConfigItems from './PaperConfigItems'
import './Print.css'
// import HTML5Backend from 'react-dnd-html5-backend'
// import { DragDropContext } from 'react-dnd'
import Select from 'react-select'
import { Button, FormControl, Modal, FormGroup, Form, Col } from 'react-bootstrap'
import FontAwsome from 'react-fontawesome'
import IframeModal from 'component/element/IframeModal'
import No_img from 'asset/img/no_image.jpg'
import { Checkbox, Radio } from 'react-icheck'


const localStorageKey = 'kkc.print-continuous-paper-config'
const NotificationSystem = require('react-notification-system')
const dot = require('dot-object')
var DEFAULT_ROW = 15
var cssPagedMedia = (function() {
  var style = document.createElement('style');
  document.head.appendChild(style);
  return function (rule) {
    style.innerHTML = rule;
  };
}());
cssPagedMedia.size = function(size) {
  cssPagedMedia('@page {size: ' + size + '}');
};
class PrintContinuousPaperConfig extends Component {

  constructor(props){
    super(props)
    this.state = {
      loading:false,
      data:[],
      dataDrop:[],
      dataList:[],
      dataField:undefined,
      templateList:[{label:'-- เลือกเทมเพลต --',value:''}],
      template:'',
      keyTemplate:-1,
      keyExpand:-1,
      itemIsNumber:false,
      isNumber:false,
      digit:'',
      imgs:[],
      lightboxIsOpen:false,
      snapToGridAfterDrop:false,
      snapToGridWhileDragging:false,
      showBg:false,
      items:[],
      _items:[],
      itemsExpand:[],
      itemsDel:[],
      search:'',
      rowPerPage:DEFAULT_ROW,
      margin:'35',
      checkDataDrop:false,
      showField:false,
      height:props.height,
      sizePage: JSON.parse(localStorage.getItem(localStorageKey)) || {page:'a4-onlineview'},
      showStyleConfig:false
    }
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem
    this.loadData()
    this.setSideBarHeight()
  }

  setSideBarHeight() {
    this.setState({height: (window.innerHeight-550) + 'px'})
  }

  checkIsArray(item,dataField) {
    const objArr = item.field.split('.')
    let isArray = false
    for (var i=0;i<objArr.length;i++) {
      if (Array.isArray(dataField[objArr[i]]))
        isArray = true
    }
    return isArray
  }

  getNewApiUrl(key,search,data) {
    let url = data[key].request_api    
    let param = url.substring(
      url.lastIndexOf("&") + 1, 
      url.lastIndexOf("=")
    )
    return url.replace('%{'+param+'}', search)
  }

  getFieldDataList(field) {
    const objArr = field.split('.')
    if (objArr.length>0) {
      return objArr[objArr.length-1]
    }
    return undefined
  }

  getPagination(data,key,_items,dataField) {
    let rowPerPage = data[key].row_per_page
    let margin = data[key].margin
    let {itemsDel} = this.state
    DEFAULT_ROW = (rowPerPage!=undefined&&rowPerPage!=null&&rowPerPage!=''&&!isNaN(rowPerPage)?rowPerPage:DEFAULT_ROW)
    DEFAULT_ROW = DEFAULT_ROW*1
    let fieldItemList = []
    let fieldItemListGroup = []
    let noArr = []
    const tgt = dot.dot(dataField)
    data[key].position.forEach((item,index)=>{
      let checkObj = false
      Object.keys(tgt).map(function(objectKey, objIndex) {
        if (item.field==objectKey)
          checkObj = true
      })
      if (checkObj) {
        const objArr = item.field.split('.')
        if (item.expand) {
          fieldItemList.push({index:objArr[1],field:item.field,id:item.id,x:item.x,title:item.title,y:item.y,isArray:true,expand:true,width:item.width,text_align:item.text_align,digit:item.digit})
          fieldItemListGroup.push({index:objArr[1],field:item.field,id:item.id,x:item.x,title:item.title,y:item.y,isArray:true,expand:true,width:item.width,text_align:item.text_align,digit:item.digit})
          const left = item.x
          const top = item.y
          let i = 0
          _items.forEach((sitem,sindex)=>{
            const _objArr = sitem.field.split('.')
            if ((objArr.length>0&&_objArr.length>0)&&(objArr.length==_objArr.length)) {
              if ((objArr[0]==_objArr[0])&&(objArr[objArr.length-1]==_objArr[_objArr.length-1])&&(sitem.field!=item.field)&&(sitem.id>=item.id)) {
                i++
              }  
              if ((objArr[0]==_objArr[0])&&(objArr[objArr.length-1]==_objArr[_objArr.length-1])&&(sitem.field!=item.field)&&(sitem.id>=item.id)) { // &&(data[key].position.findIndex(x=>x.id==sitem.id)==-1)
                sitem.left = left
                sitem.top = (margin*i)+top
                fieldItemList.push({index:_objArr[1],field:sitem.field,id:sitem.id,x:sitem.left,title:sitem.title,y:sitem.top,isArray:true,width:item.width,text_align:item.text_align,digit:item.digit})
                fieldItemListGroup.push({index:_objArr[1],field:sitem.field,id:sitem.id,x:sitem.left,title:sitem.title,y:sitem.top,isArray:true,width:item.width,text_align:item.text_align,digit:item.digit})
              }
            }
          })  
        } else {
          let isArray = this.checkIsArray(item,dataField)
          if (isArray)
            fieldItemList.push({index:objArr[1],field:item.field,id:item.id,x:item.x,title:item.title,y:item.y,isArray:true,width:item.width,text_align:item.text_align,digit:item.digit})
          else
            noArr.push({field:item.field,id:item.id,left:item.x,top:item.y,title:item.title,width:item.width,text_align:item.text_align,digit:item.digit})
        } 
      }
    })
    let orderItemList = JSON.parse(JSON.stringify(fieldItemList))
    fieldItemList.sort(function(a, b) {
      if(a.index*1 < b.index*1) return -1;
      if(a.index*1 > b.index*1) return 1;
      return 0;
    })
    fieldItemListGroup.sort(function(a, b) {
      if(a.index*1 < b.index*1) return -1;
      if(a.index*1 > b.index*1) return 1;
      return 0;
    })
    orderItemList.sort(function(a, b) {
      if(a.y*1 < b.y*1) return -1;
      if(a.y*1 > b.y*1) return 1;
      return 0;
    })
    
    let checkFieldItemListGroup = []
    fieldItemListGroup.forEach((item,index)=>{
      if (checkFieldItemListGroup.indexOf(this.getFieldDataList(item.field))==-1)
        checkFieldItemListGroup.push(this.getFieldDataList(item.field))
    })

    let newData = []
    let allData = []
    let checkRow = -1
    let checkLineheight = -1
    let isCheck = undefined
    let constTop = (orderItemList.length>0?orderItemList[0].y:0)
    let top = (orderItemList.length>0?orderItemList[0].y:0)
    fieldItemList.forEach((item,index)=>{
      if (isCheck!=item.index*1||isCheck==undefined) {
        checkRow++
        checkLineheight++
        top = (allData.length>0?(checkLineheight*(margin*1))+constTop:item.y)
      }
      isCheck = item.index*1  
      if (checkRow<DEFAULT_ROW) {
        if (itemsDel.indexOf(item.id)==-1)
          newData.push({field:item.field,id:item.id,isArray:true,left:item.x,top:top,title:item.title,width:item.width,text_align:item.text_align,digit:item.digit})
      }  
      
      if (checkRow===(checkFieldItemListGroup.length<=1?DEFAULT_ROW-1:DEFAULT_ROW)||index===fieldItemList.length-1) {
        allData.push(newData)
        top = constTop
        if (checkRow===DEFAULT_ROW) {
          newData = []
          if (itemsDel.indexOf(item.id)==-1) {
            newData.push({field:item.field,id:item.id,isArray:true,left:item.x,top:top,title:item.title,width:item.width,text_align:item.text_align,digit:item.digit})
          }
          checkRow = 0
          checkLineheight = 0
          isCheck = item.index*1
        } else {
          newData = []
          checkRow = -1
          checkLineheight = -1
          isCheck = undefined
        }  
      }
    })
    allData.forEach((item,index)=>{
      const isArrayKey = item.findIndex(x=>x.isArray==true)
      if (isArrayKey==-1)
        allData.splice(index,1)
    })
    if (allData.length>0) {
      allData.forEach((item,index)=>{
        allData[index] = allData[index].concat(noArr)
      })
    } else {
      allData.push(noArr)
    }
    return allData
  }

  loadData() {
    AdminStore.loadConfigContinuousPaper((result)=>{
      if (result.data.length>0&&result.data!=undefined) {
        let templateList = [{label:'-- เลือกเทมเพลต --',value:''}]
        result.data.forEach((item,index)=>{
          templateList.push({label:item.title,value:item.pdfid})
          result.data[index] = Object.assign({row_per_page:DEFAULT_ROW.toString(),margin:'35'}, result.data[index])
        })
        let {keyTemplate,search,template} = this.state
        if (this.props.pdfid!=undefined&&this.props.id!=undefined) {
          const key = result.data.findIndex(x=>x.pdfid==this.props.pdfid)
          if (key!=-1) {
            keyTemplate = key
            const newUrl = this.getNewApiUrl(keyTemplate,this.props.id,result.data)
            this.loadApi(newUrl,keyTemplate,result.data)
            search = this.props.id
            template = this.props.pdfid
          }
        }
        this.setState({data:result.data,templateList:templateList,imgs:result.files,keyTemplate:keyTemplate,search:search,template:template})
      }
    })
  }

  loadApi(url,key,data) {
    let margin = data[key].margin
    if (key!=-1) {
      PdfStore.loadCustomApi(url,(result)=>{
        if (result.data!=undefined&&result.data!=''&&result.data!=null) {
          let items = []
          let _items = []
          let dataDrop = []
          const tgt = dot.dot(result.data)
          data[key].position.forEach((item,index)=>{
            let checkObj = false
            Object.keys(tgt).map(function(objectKey, objIndex) {
              if (item.field==objectKey)
                checkObj = true
            })  
            if (checkObj) {
              let title = item.field.split('.').reduce((o,i)=>o[i], result.data)
              if (item.x>'0'&&item.y>'0') {
                dataDrop.push({id:item.id,field:item.field,title:title,top:parseFloat(item.y),left:parseFloat(item.x)})
              }
              data[key].position[index].title = title
            }  
          })

          Object.keys(tgt).map(function(objectKey, index) {
            const objArr = objectKey.split('.')
            let isArray = false
            for (var i=0;i<objArr.length;i++) {
              if (Array.isArray(result.data[objArr[i]]))
                isArray = true
            }
            const value = tgt[objectKey]
            const key = dataDrop.findIndex(x=>x.field==objectKey)
            if (key==-1) {
              if (isArray)
                items.push({id:index,field:objectKey,title:value,top:'0',left:'0',isArray:true})
              else
                items.push({id:index,field:objectKey,title:value,top:'0',left:'0'})
            } else {
              if (isArray)
                dataDrop[key] = Object.assign({isArray:true}, dataDrop[key])
            }
            if (isArray)
              _items.push({id:index,field:objectKey,title:value,top:'0',left:'0',isArray:true})
            else
              _items.push({id:index,field:objectKey,title:value,top:'0',left:'0'})
          })

          let idDup = []
          data[key].position.forEach((item,index)=>{
            if (item.expand) {
              data[key].position[index] = Object.assign({width:'auto',text_align:'center'}, data[key].position[index])
              const objArr = item.field.split('.')
              const left = item.x
			        const top = item.y
              let i = -1
              _items.forEach((sitem,sindex)=>{
                const _objArr = sitem.field.split('.')
                if ((objArr.length>0&&_objArr.length>0)&&(objArr.length==_objArr.length)) {
                  if ((objArr[0]==_objArr[0])&&(objArr[objArr.length-1]==_objArr[_objArr.length-1])) {
                    i++
                  }  
                  if ((objArr[0]==_objArr[0])&&(objArr[objArr.length-1]==_objArr[_objArr.length-1])&&(sitem.field!=item.field)&&(sitem.id>item.id)&&(data[key].position.findIndex(x=>x.id==sitem.id)==-1)) {
                    sitem.left = left
                    sitem.top = (margin*i)+top
                    dataDrop.push({field:sitem.field,id:sitem.id,left:sitem.left,title:sitem.title,top:sitem.top,isArray:true})
                    idDup.push(sitem.id)
                  }
                }
              })  
            }  
          })
          if (idDup.length>0) {
            idDup.forEach((item,index)=>{
              const keyDel = items.findIndex(x=>x.id==item)
              if (keyDel!=-1)
                items.splice(keyDel,1)
            })
          }
          items.sort(function(a, b) {
            if(a.field < b.field) return -1;
            if(a.field > b.field) return 1;
            return 0;
          })
          this.setState({items:items,_items:_items,dataField:result.data,data:data,dataList:this.getPagination(data,key,_items,result.data),checkDataDrop:true})
        }
      },()=>{
        this.setState({search:'',items:[],_items:[],dataField:undefined})
      })
    }
  }

  onShowBgChange() {
    let {showBg,data,keyTemplate,dataList} = this.state
    const ele = document.getElementsByClassName("sliptable-continuous-paper-config-page-desktop")
    if (showBg) {
      showBg = false
      if (dataList.length==0) {
        ele[0].style.removeProperty('background-image')
      } else {
        dataList.forEach((item,index)=>{
          ele[index].style.removeProperty('background-image')
        })
      }  
    } else { 
      showBg = true
      if (keyTemplate!=-1) {
        if (dataList.length==0) {
          ele[0].style.setProperty('background-image', 'url('+data[keyTemplate].pdf_image_url+')', 'important')
        } else {  
          dataList.forEach((item,index)=>{
            ele[index].style.setProperty('background-image', 'url('+data[keyTemplate].pdf_image_url+')', 'important')
          })
        }    
      }  
    }
    this.setState({showBg:showBg})
  }

  onSetBgChange(dataList) {
    let {showBg,data,keyTemplate} = this.state
    const ele = document.getElementsByClassName("sliptable-continuous-paper-config-page-desktop")
    if (showBg) {
      if (keyTemplate!=-1) {
        if (dataList.length<=ele.length) {
          dataList.forEach((item,index)=>{
            ele[index].style.setProperty('background-image', 'url('+data[keyTemplate].pdf_image_url+')', 'important')
          })
        }    
      }  
    } else { 
      if (dataList.length<=ele.length) {
        dataList.forEach((item,index)=>{
          ele[index].style.removeProperty('background-image')
        })
      }  
    }
  }

  onItemDrag = (item,index) => {
    let {items,_items} = this.state
    const key = _items.findIndex(x=>x.id==item.id)
    _items[key].left = item.left
    _items[key].top = item.top
    items.splice(index,1)
    this.setState({_items:_items,items:items})
  }

  onItemDrop(items) {
    let {_items,data,keyTemplate,dataField} = this.state
    let checkItemDrop = []
    data[keyTemplate].position.forEach((item,index)=>{
      if (item.expand) {
        const objArr = item.field.split('.')
        _items.forEach((sitem,sindex)=>{
          const _objArr = sitem.field.split('.')
          if ((objArr.length>0&&_objArr.length>0)&&(objArr.length==_objArr.length)) {
            if ((objArr[0]==_objArr[0])&&(objArr[objArr.length-1]==_objArr[_objArr.length-1])&&(sitem.field!=item.field)&&(sitem.id>item.id)&&(data[keyTemplate].position.findIndex(x=>x.id==sitem.id)==-1)) {
              checkItemDrop.push(sitem)
            }
          }
        })  
      } 
    })

    items.forEach((item,index)=>{
      const dataKey = data[keyTemplate].position.findIndex(x=>x.id==item.id)
      if (dataKey!=-1) {
        data[keyTemplate].position[dataKey].x = item.left
        data[keyTemplate].position[dataKey].y = item.top
      } else {
        const pushKey = checkItemDrop.findIndex(x=>x.id==item.id)
        if (pushKey==-1) {
          let isArray = this.checkIsArray(item,dataField)
          if (isArray)
            data[keyTemplate].position.push({title:item.title,x:item.left,y:item.top,field:item.field,id:item.id,isArray:true})
          else
            data[keyTemplate].position.push({title:item.title,x:item.left,y:item.top,field:item.field,id:item.id})  
        }  
      }
      const key = _items.findIndex(x=>x.id==item.id)
      if (key!=-1) {
        _items[key].top = item.top
        _items[key].left = item.left
      }
    })
    this.setState({_items:_items,data:data})
  }

  onUploadClick() {
    let url = ''
    if (process.env.NODE_ENV == "development") {
      url = 'https://demo2.bigfix.co/korat/fup/fileupload.html?cat=pdftemplate'
    } else {
      url = './fup/fileupload.html?cat=pdftemplate'
    }
    
    this.refs.iframe.loadUrl(url)
  }

  onUpImgHide() {
  	this.loadData()
  }

  onTemplateChange(e) {
    let {data,showBg,dataList,search} = this.state
    const key = data.findIndex(x=>x.pdfid==e.value)
    const ele = document.getElementsByClassName("sliptable-continuous-paper-config-page-desktop")
    if (e.value!=''&&key!=-1) {
      if (showBg) {
        dataList.forEach((item,index)=>{
          ele[index].style.setProperty('background-image', 'url('+data[key].pdf_image_url+')', 'important')
        })
      } else { 
        dataList.forEach((item,index)=>{
          ele[index].style.removeProperty('background-image')
        })
      }
      this.setState({template:e.value,keyTemplate:key,items:[],_items:[],checkDataDrop:true,dataDrop:[]},()=>{
        const newUrl = this.getNewApiUrl(key,search,data)
        this.loadApi(newUrl,key,data)
      })
    } else {
      dataList.forEach((item,index)=>{
        ele[index].style.removeProperty('background-image')
      })
      this.setState({template:e.value,keyTemplate:-1,items:[],_items:[],search:'',checkDataDrop:true,dataDrop:[]})
    }
  }

  onMarginChange(e) {
    let {data,keyTemplate,margin} = this.state
    margin = e.target.value
    data[keyTemplate].margin = margin
    this.setState({margin:margin,data:data})
  }

  onMarginPress(e) {
    let {keyTemplate,data,_items,dataField,dataList} = this.state
    if (e.charCode==13) {
      dataList = this.getPagination(data,keyTemplate,_items,dataField)
      this.setState({dataList:dataList,checkDataDrop:true})
    }
  }

  onRowPerPageChange(e) {
    let {data,keyTemplate,rowPerPage} = this.state
    rowPerPage = e.target.value
    data[keyTemplate].row_per_page = rowPerPage
    this.setState({rowPerPage:rowPerPage,data:data})
  }

  onRowPerPagePress(e) {
    let {keyTemplate,data,_items,dataField,dataList} = this.state
    if (e.charCode==13) {
      dataList = this.getPagination(data,keyTemplate,_items,dataField)
      this.setState({dataList:dataList,checkDataDrop:true})
    }
  }

  onSearchChange(e) {
    this.setState({search:e.target.value})
  }

  onSearchPress(e) {
    let {keyTemplate,search,data} = this.state
    if (e.charCode==13) {
      if (keyTemplate!=-1) {
        const newUrl = this.getNewApiUrl(keyTemplate,search,data)
        this.loadApi(newUrl,keyTemplate,data)
      }
    }
  }

  onSaveClick() {
    let {data,keyTemplate,itemsExpand,dataList,_items,dataField} = this.state
    if (keyTemplate!=-1) {
      itemsExpand.forEach((ritem,rindex)=>{
        const objArr = ritem.field.split('.')
        data[keyTemplate].position.forEach((item,index)=>{
          const _objArr = item.field.split('.')
          if ((objArr.length>0&&_objArr.length>0)&&(objArr.length==_objArr.length)) {
            if ((ritem.fieldF==_objArr[0])&&(ritem.fieldL==_objArr[_objArr.length-1])&&(item.expand)) {
              data[keyTemplate].position[index] = Object.assign(data[keyTemplate].position[index], {expand:true,title:ritem.title,id:ritem.id,isArray:true,field:ritem.field,x:ritem.x,y:ritem.y,text_align:ritem.text_align,width:ritem.width,digit:ritem.digit})
            }
          }
        })
      })
      let position = data[keyTemplate].position
      let postData = {pdfid:data[keyTemplate].pdfid,title:data[keyTemplate].title,position:position,request_api:data[keyTemplate].request_api,pdf_image_url:data[keyTemplate].pdf_image_url,pdf_image_name:data[keyTemplate].pdf_image_name,row_per_page:data[keyTemplate].row_per_page,margin:data[keyTemplate].margin} 
      AdminStore.saveConfigContinuousPaper(postData,(result)=>{
        if (result.status=='OK') {
          this._notificationSystem.addNotification({
            title: 'แจ้งเตือน',
            message: 'ทำการบันทึกรายละเอียดเรียบร้อย',
            level: 'info',
            position: 'tc',        
          })
          dataList = this.getPagination(data,keyTemplate,_items,dataField)
          this.setState({dataList:dataList,checkDataDrop:true})
        }
      })
    } else {
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'กรุณาเลือกเทมเพลต',
        level: 'error',
        position: 'tc'
      })
    }
  }

  onResetDataDrop() {
    this.setState({checkDataDrop:false})
    this.onSetBgChange(this.state.dataList)
  }

  onItemDeleteClick(id) {
    let {items,_items,data,keyTemplate,dataField,itemsDel} = this.state
    const dataKey = data[keyTemplate].position.findIndex(x=>x.id==id)
    if (dataKey!=-1) {
      if (data[keyTemplate].position[dataKey].isArray)
        itemsDel.push(id)

      data[keyTemplate].position.splice(dataKey,1)
    } else {
      itemsDel.push(id)
    }
    
    const key = _items.findIndex(x=>x.id==id)
    if (key!=-1) {
      const item = _items[key]
      item.top = '0'
      item.left = '0'
      items.push(item)

      const objArr = item.field.split('.')
      _items.forEach((sitem,sindex)=>{
        const _objArr = sitem.field.split('.')
        if ((objArr.length>0&&_objArr.length>0)&&(objArr.length==_objArr.length)) {
          if ((objArr[0]==_objArr[0])&&(objArr[objArr.length-1]==_objArr[_objArr.length-1])&&(sitem.id>item.id)) {
            sitem.top = '0'
            sitem.left = '0'
            items.push(sitem)
          }
        }
      })

      items.sort(function(a, b) {
        if(a.id < b.id) return -1;
        if(a.id > b.id) return 1;
        return 0;
      })
    }
    this.setState({items:items,_items:_items,data:data,itemsDel:itemsDel,dataList:this.getPagination(data,keyTemplate,_items,dataField),checkDataDrop:true})
  }

  onExpandClick(drops,expandId,thisItem) {
    let {items,_items,data,keyTemplate,dataList,itemsExpand,dataField,itemsDel} = this.state
    const dataKey = data[keyTemplate].position.findIndex(x=>x.id==expandId)
    if (dataKey!=-1) {
      const objArr = data[keyTemplate].position[dataKey].field.split('.')
      let checkExpand = false
      let checkExpandId = undefined
      let checkDelExpadId = []
      data[keyTemplate].position.forEach((item,index)=>{
        const _objArr = item.field.split('.')
        if ((objArr.length>0&&_objArr.length>0)&&(objArr.length==_objArr.length)) {
          if ((objArr[0]==_objArr[0])&&(objArr[objArr.length-1]==_objArr[_objArr.length-1])) {
            if (item.expand==true) {
              checkExpand = true
              checkExpandId = item.id
            }  
          }
          if ((objArr[0]==_objArr[0])&&(objArr[objArr.length-1]==_objArr[_objArr.length-1])&&(item.id>data[keyTemplate].position[dataKey].id)) {
            checkDelExpadId.push(item.id)
          }  
        }
      })
      
      data[keyTemplate].position[dataKey] = Object.assign({expand:true,isArray:true}, data[keyTemplate].position[dataKey])
      if (checkExpand) {
        const delExpandKey = data[keyTemplate].position.findIndex(x=>x.id==checkExpandId)
        if (delExpandKey!=-1) {
          if (checkExpandId!=data[keyTemplate].position[dataKey].id)
            delete data[keyTemplate].position[delExpandKey]['expand']
          
          checkDelExpadId.forEach((item,index)=>{
            const delItemKey = data[keyTemplate].position.findIndex(x=>x.id==item)
            if (delItemKey!=-1)
              data[keyTemplate].position.splice(delItemKey,1)
          })
        }  
      } else {
        checkDelExpadId.forEach((item,index)=>{
          const delItemKey = data[keyTemplate].position.findIndex(x=>x.id==item)
          if (delItemKey!=-1)
            data[keyTemplate].position.splice(delItemKey,1)
        })
      }
      drops.forEach((item,index)=>{
        if ((item.id!=expandId)&&(data[keyTemplate].position.findIndex(x=>x.id==item.id)==-1)) {
          const keyDel = items.findIndex(x=>x.id==item.id)
          if (keyDel!=-1) {
            items.splice(keyDel,1)
          }
        }  
      })
      
      this.setState({itemsDel:[]})
      setTimeout(()=>{
        dataList = this.getPagination(data,keyTemplate,_items,dataField)
        this.setState({items:items,_items:_items,data:data,dataList:dataList,checkDataDrop:true})    
      }, 100)
    } else {
      /* change expand */
      const objArr = thisItem.field.split('.')
      data[keyTemplate].position.forEach((item,index)=>{
        const _objArr = item.field.split('.')
        if ((objArr.length>0&&_objArr.length>0)&&(objArr.length==_objArr.length)) {
          if ((objArr[0]==_objArr[0])&&(objArr[objArr.length-1]==_objArr[_objArr.length-1])) {
            const _itemsExpand = {expand:true,isArray:true,x:thisItem.left,y:thisItem.top,id:thisItem.id,title:thisItem.title,field:thisItem.field,fieldF:_objArr[0],fieldL:_objArr[_objArr.length-1]}
            const expandKey = itemsExpand.findIndex(x=>x.fieldF==_objArr[0]&&x.fieldL==_objArr[_objArr.length-1])
            if (expandKey==-1) {
              itemsExpand.push(_itemsExpand)
            } else {
              itemsExpand[expandKey] = _itemsExpand
            }
          }
        }
      })
      this.setState({itemsDel:[]})
      setTimeout(()=>{
        dataList = this.getPagination(data,keyTemplate,_items,dataField)
        this.setState({items:items,_items:_items,data:data,dataList:dataList,checkDataDrop:true,itemsExpand:itemsExpand})    
      }, 100)
    }
  }

  onBoxDbClick(id) {
    let {data,keyTemplate,itemIsNumber,isNumber,digit} = this.state
    const expandKey = data[keyTemplate].position.findIndex(x=>x.id==id)
    if (expandKey!=-1) {
      if (data[keyTemplate].position[expandKey].title!=undefined&&data[keyTemplate].position[expandKey].title!=''&&data[keyTemplate].position[expandKey].title!=null&&!isNaN(data[keyTemplate].position[expandKey].title)) {
        itemIsNumber = true
        if (data[keyTemplate].position[expandKey].digit!=undefined&&data[keyTemplate].position[expandKey].digit!=''&&data[keyTemplate].position[expandKey].digit!=null&&!isNaN(data[keyTemplate].position[expandKey].digit)) {
          isNumber = true
          digit = data[keyTemplate].position[expandKey].digit
        }
      }
      this.setState({showStyleConfig:true,keyExpand:expandKey,itemIsNumber:itemIsNumber,isNumber:isNumber,digit:digit})
    }
  }

  onShowFieldChange() {
    let {showField} = this.state
    if (showField)
      showField = false
    else
      showField = true
    
    this.setState({showField:showField})  
  }

  onOptionSizeChange(size) {
    let {sizePage,data,keyTemplate,_items,dataField} = this.state
    sizePage.page = (size.value=='Letter'?'letter-onlineview':'a4-onlineview')

    if(size.value=='Letter')
      cssPagedMedia.size('210mm 280mm')
    else
      cssPagedMedia.size('240mm 339.1mm')

    let sizePageConfig = {page:sizePage.page}
    localStorage.setItem(localStorageKey, JSON.stringify(sizePageConfig))
    this.setState({sizePage:sizePage,dataList:this.getPagination(data,keyTemplate,_items,dataField),checkDataDrop:true})
  }

  onBgPreviewClick(item) {
    let {data,keyTemplate,showBg,dataList} = this.state
    data[keyTemplate].pdf_image_name = item.name
    data[keyTemplate].pdf_image_url = item.url

    const ele = document.getElementsByClassName("sliptable-continuous-paper-config-page-desktop")
    if (!showBg) {
      dataList.forEach((item,index)=>{
        ele[index].style.removeProperty('background-image')
      })
    } else {
      if (keyTemplate!=-1) {
        dataList.forEach((item,index)=>{
          ele[index].style.setProperty('background-image', 'url('+data[keyTemplate].pdf_image_url+')', 'important')
        })
      }  
    }

    this.setState({data:data})
  }

  onStyleChange(key,e) {
    let {data,keyTemplate,keyExpand} = this.state
    data[keyTemplate].position[keyExpand][key] = e.target.value
    this.setState({data:data})
  }

  onTextAlignChange(text_align) {
    let {data,keyTemplate,keyExpand} = this.state
    data[keyTemplate].position[keyExpand].text_align = text_align
    this.setState({data:data})
  }

  onIsNumberChange() {
    let {data,keyTemplate,keyExpand,isNumber,digit} = this.state
    if (isNumber) {
      isNumber = false
      delete data[keyTemplate].position[keyExpand]['isNumber']
      delete data[keyTemplate].position[keyExpand]['digit']
    } else {
      isNumber = true
      data[keyTemplate].position[keyExpand] = Object.assign({isNumber:isNumber,digit:digit}, data[keyTemplate].position[keyExpand])
    }  
    this.setState({isNumber:isNumber,data:data})
  }

  onDigitChange(e) {
    let {data,keyTemplate,keyExpand,digit} = this.state
    digit = e.value
    data[keyTemplate].position[keyExpand].digit = digit
    this.setState({digit:digit,data:data})
  }

  onStyleSaveClick() {
    this.setState({showStyleConfig:false,keyExpand:-1,itemIsNumber:false,isNumber:false,digit:''},()=>{
      this.onSaveClick()
    })
  }

  renderOptionSeting() {
    const {data,items,keyTemplate,templateList,template,imgs,showField,rowPerPage,margin} = this.state
    return([
            <li key={0}>
                <a style={{padding:'5px 15px'}}>
                  {keyTemplate!=-1?data[keyTemplate].title:'...'}
                  <Select
                    placeholder={'-- เลือกเทมเพลต --'}
                    clearable={false}
                    options={templateList}
                    value={template}
                    onChange={this.onTemplateChange.bind(this)}
                  />
                </a>
            </li>,
            <li key={1}>
                <a style={{padding:'5px 15px'}}><Button bsStyle='primary' onClick={this.onUploadClick.bind(this)}><FontAwsome name="upload" />&nbsp;Upload Image</Button></a>
            </li>,
            <li key={2}>
              <a style={{overflowX:'auto',padding:'5px 15px'}}>
                <div style={{display:'inline-flex'}}>
                {keyTemplate!=-1&&imgs.length>0?imgs.map((item,index)=>{
                  return(
                    <div style={{position:'relative',width:'54px',height:'54px',marginRight:'10px'}} key={index} onClick={this.onBgPreviewClick.bind(this,item)}>
                      <div style={{border:'1px solid #fff',borderRadius:'8px',backgroundImage:'url('+item.thumbnailUrl+')',backgroundPosition:'50% 50%',backgroundRepeat:'no-repeat',height:'54px',width:'54px',backgroundSize:'cover'}}></div>
                      {data[keyTemplate].pdf_image_name==item.name?<FontAwsome name='check' style={{color:'#5cb85c',position:'absolute',top:2,right:2}} />:''}
                    </div>
                  )    
                }):
                <div style={{position:'relative',width:'54px',height:'54px',marginRight:'10px'}}>
                  <div style={{border:'1px solid #fff',borderRadius:'8px',backgroundImage:'url('+No_img+')',backgroundPosition:'50% 50%',backgroundRepeat:'no-repeat',height:'54px',width:'54px',backgroundSize:'cover'}}></div>
                </div>
                }  
                </div>  
              </a>  
  	  	  	</li>,
            <li key={3}>
              <a style={{padding:'5px 15px'}}>
                <Button bsStyle='success' onClick={this.onSaveClick.bind(this)}><FontAwsome name='save' />&nbsp;บันทึก</Button>
                &nbsp;
                <Checkbox
                  onChange={this.onShowFieldChange.bind(this)}
                  checked={showField}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label={''}
                >
                </Checkbox>
              </a>
            </li>,
            <li key={4}>
              <a style={{padding:'5px 15px'}}>
                ระยะห่างระหว่างบรรทัด
                <FormControl 
                  value={data.length==0||keyTemplate==-1?margin:data[keyTemplate].margin} 
                  onChange={this.onMarginChange.bind(this)} 
                  onKeyPress={this.onMarginPress.bind(this)} 
                />
              </a>
            </li>,
            <li key={5}>
              <a style={{padding:'5px 15px'}}>
                จำนวนแถว / หน้า
                <FormControl
                  value={data.length==0||keyTemplate==-1?rowPerPage:data[keyTemplate].row_per_page}
                  onChange={this.onRowPerPageChange.bind(this)} 
                  onKeyPress={this.onRowPerPagePress.bind(this)} 
                />
              </a>
            </li>,
            <li key={6}>
              <a style={{padding:'5px 15px'}}>
                ID
                <FormControl 
                  value={this.state.search} 
                  onChange={this.onSearchChange.bind(this)} 
                  onKeyPress={this.onSearchPress.bind(this)} 
                />
              </a>
            </li>,
            <li key={7}>
              <a style={{overflowY:'auto',maxHeight:this.state.height,padding:'5px 15px'}}>
                {items.map((item,index)=> {
                  return(
                    <div key={index} style={{display:'inline-flex',width:'500px'}}>                      
                      <PaperConfigItems 
                        key={index} 
                        item={item} 
                        index={index}
                        handleDrop={(item,index)=>this.onItemDrag(item,index)}
                      />
                    </div>  
                  )  
                })}
              </a>
            </li>
          
    ])
  }

  renderComponentPage(item,index) {
    const {snapToGridAfterDrop,_items,checkDataDrop,showField,sizePage,data,keyTemplate,margin} = this.state
    const _margin = (data.length==0||keyTemplate==-1?margin:data[keyTemplate].margin)
    return(
      <Container
        key={index}
        margin={_margin}
        sizePage={sizePage.page}
        showField={showField}
        checkDataDrop={checkDataDrop}
        items={_items} 
        dataDrop={item}
        handleDrop={this.onItemDrop.bind(this)} 
        snapToGrid={snapToGridAfterDrop} 
        onResetDataDrop={this.onResetDataDrop.bind(this)}
        onItemDeleteClick={this.onItemDeleteClick.bind(this)}
        onExpandClick={this.onExpandClick.bind(this)}
        onBoxDbClick={this.onBoxDbClick.bind(this)}
      />
    )
  }

  renderStyleForm() {
    let {data,keyTemplate,keyExpand,itemIsNumber,isNumber,digit} = this.state
    let width = 'auto'
    let textAlign = 'center'
    if (data.length>0&&keyTemplate!=-1&&keyExpand!=-1) {
      width = data[keyTemplate].position[keyExpand].width
      textAlign = data[keyTemplate].position[keyExpand].text_align
    }
    return(
      <Form horizontal>
        <FormGroup controlId="formHorizontalEmail">
          <Col sm={3}>
            Width
          </Col>
          <Col sm={7}>
            <FormControl value={width} onChange={this.onStyleChange.bind(this,'width')} />
          </Col>
        </FormGroup>
        <FormGroup controlId="formHorizontalEmail">
          <Col sm={3}>
            Text Align
          </Col>
          <Col sm={7}>
            <Radio
              onChange={this.onTextAlignChange.bind(this,'left')}
              checked={textAlign=='left'?true:false}
              radioClass="iradio_square-blue"
              increaseArea="20%"
              label={' Left'}
            >
            </Radio>
            &nbsp;
            <Radio
              onChange={this.onTextAlignChange.bind(this,'center')}
              checked={textAlign=='center'||textAlign==''||textAlign==undefined?true:false}
              radioClass="iradio_square-blue"
              increaseArea="20%"
              label={' Center'}
            >
            </Radio>
            &nbsp;
            <Radio
              onChange={this.onTextAlignChange.bind(this,'right')}
              checked={textAlign=='right'?true:false}
              radioClass="iradio_square-blue"
              increaseArea="20%"
              label={' Right'}
            >
            </Radio>
          </Col>
        </FormGroup>
        {itemIsNumber?
        <FormGroup controlId="formHorizontalEmail">
          <Col sm={3}>
            Number Format
          </Col>
          <Col sm={7}>
            <Checkbox
              onChange={this.onIsNumberChange.bind(this,isNumber)}
              checked={isNumber}
              checkboxClass="icheckbox_square-blue"
              increaseArea="20%"
              label={' เลือก'}
            >
            </Checkbox>
          </Col>  
        </FormGroup>:
        ''}
        {isNumber?
        <FormGroup controlId="formHorizontalEmail">
          <Col sm={3}>
            Digit
          </Col>
          <Col sm={7}>
            <Select
              placeholder={'-- เลือก Digit --'}
              clearable={false}
              options={[{label:'-- เลือก Digit --',value:''},{label:'0 Digit',value:'0'},{label:'1 Digit',value:1},{label:'2 Digit',value:2}]}
              value={digit}
              onChange={this.onDigitChange.bind(this)}
            />
          </Col>  
        </FormGroup>:
        ''}
      </Form>
    )
  }

  render() {
    let {loading,showBg,sizePage,keyTemplate,data,dataList,showStyleConfig} = this.state
    return(
      <div>
        <PrintPreview 
        	size={'portrait'}
            loading={loading}
            leftBarTitle={keyTemplate!=-1?data[keyTemplate].title:this.props.title}
            sideBarPaperConfig={true}
            sliptable={'sliptable-continuous-paper-config-page-desktop'+(showBg?' paper-config-bg':'')}
            onlineview={sizePage.page}
            renderOptionSeting={this.renderOptionSeting.bind(this)}
            showBg={showBg}
            showSetting={true}
            onShowBgChange={this.onShowBgChange.bind(this)}
            optionSize={sizePage.page=='a4-onlineview'?'A4':'Letter'}
            onOptionSizeChange={this.onOptionSizeChange.bind(this)}
            showPageNumber={false}
        >
          {
            dataList.map((item,index)=>{
              return this.renderComponentPage(item,index)
            })  
          }    
        </PrintPreview>
        <NotificationSystem ref="notificationSystem" />
        <IframeModal ref='iframe' title='อับโหลดรูป' modal={true} onUpImgHide={this.onUpImgHide.bind(this)} />
        <Modal show={showStyleConfig} onHide={()=>{this.setState({showStyleConfig:false,keyExpand:-1,itemIsNumber:false,isNumber:false,digit:''})}}>
          <Modal.Header closeButton>
            <Modal.Title>ตั้งค่า Style</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.renderStyleForm()}
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle='primary' onClick={this.onStyleSaveClick.bind(this)}><FontAwsome name='save' />&nbsp;บันทึก</Button>
            <Button onClick={()=>{this.setState({showStyleConfig:false,keyExpand:-1,itemIsNumber:false,isNumber:false,digit:''})}}><FontAwsome name='close' />&nbsp;ปิด</Button>
          </Modal.Footer>
        </Modal>
      </div>  
    )
  }
}
PrintContinuousPaperConfig.defaultProps = {
  title: 'Print Continuous Paper Config'
}

// export default DragDropContext(HTML5Backend)(PrintContinuousPaperConfig);
export default PrintContinuousPaperConfig;


// WEBPACK FOOTER //
// ./src/view/print/paperconfig/PrintContinuousPaperConfig.js